import * as React from 'react';
import styles from './list-view-item.scss';
import { Icon } from 'ui/common/icon';
import { AppSetting } from 'dependencies/appsettings';
import { Component } from 'react';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export interface ListViewItemProps {
  option: CodeComplexValue<number>;
  onClick: (breadcrumbs: number[]) => void;
  breadcrumbs: CodeComplexValue<number>[];
  displayFlexibleItemName?: boolean;
}

export class ListViewItem extends Component<ListViewItemProps>  {

  private buildFullPath = (option: CodeComplexValue<number>): string =>
    option.fullPath.reduce((result: string, item: CodeComplexValue<number>) =>
      this.buildPath(result, item), '');

  private buildPath = (result: string, item: CodeComplexValue<number>): string =>
    result ? result + ' - ' + item.description : item.description;

  private onClick = () => {
    const { option, onClick, breadcrumbs } = this.props;

    option?.fullPath ? onClick([...option.fullPath.map(breadcrumbsItem => breadcrumbsItem.value), option.value])
      : onClick([...(breadcrumbs ? breadcrumbs.map(breadcrumbsItem => breadcrumbsItem.value) : []), option.value]);
  };

  private shouldShowFullPath = () => this.props.option.fullPath && this.props.option.fullPath.length > 0;

  public render() {
    const { option, displayFlexibleItemName } = this.props;

    const hostingPath = AppSetting.HostingPath || '';

    const isSearchMode = this.shouldShowFullPath();

    const iconClassName = `${styles.listViewItemIcon} ${isSearchMode ? styles.listViewItemIconOnSearch : ''}`;

    const iconTitleContainerClassName = `${styles.listViewItemIconTitleContainer} 
    ${isSearchMode ? styles.listViewItemIconTitleContainerOnSearch : ''}`;

    return (
      <div onClick={this.onClick}>
        <div className={styles.listViewItem}>
          <div className={iconTitleContainerClassName}>
            <div className={iconClassName}>
              <Icon url={option.icon || hostingPath + '/i/case-sections/default.svg'} className={styles.icon} />
            </div>
            <div className={`${styles.listViewItemTitle} ${displayFlexibleItemName ? styles.listViewItemBigTitle : ''}`}>
              {option.description}
            </div>
          </div>
          {isSearchMode
            ? <div className={styles.listViewItemSubtitleContainer}><div className={styles.listViewItemSubtitle}>
              {this.buildFullPath(option)}
            </div></div>
            : null}
        </div>
      </div>
    );
  }
}
